import React from 'react';
import Cookies from "browser-cookies";

import GuideFilter from './guide-filter';
import FilterSettings from './constants';
import LoginModal from './login-modal';


import PageGroups from './guide-components/page-groups';

var FavoritesAPI = require('../utils/favorites-api');
var FavoritesActions = require('../actions/favorites-actions');
import UserStore from '../stores/user-store';

var MobileGuideHeader = React.createClass({
  getPace: function(){
    return {1: "Slow", 2: "Medium", 3: "Fast"}[this.props.pace];
  },

  toggleShow: function(){
    Cookies.set("hasSeenFilters", "1", {expires: 365});
    this.props.onChangeView("list-view");
  },

  render: function(){
    var numPlaces = (this.props.numPlaces) ? <span>{this.props.numPlaces} Places,</span>  : null;
    var filter = this.props.filter || [];
    var filterLabels = filter.map(function(f) {
      return FilterSettings.labelMap[f];
    });
    var filterSelection = (filter.length > 0) ? <p>{filterLabels.join(', ')}</p> : null;
    
    return (
      <div className={ 'mobile-popover-wrapper ' + (this.props.mobileCurrentView === "filter-view" ? "active" : "") }>
        <div className={ "filter-summary col-xs-12 " } >
          <p>
            {numPlaces} {this.props.numDays} Days, {this.getPace()} Pace,
            Starting on {this.props.startingDate.format('MMM D, YYYY')}
          </p>
          {filterSelection}
        </div>    

        <div className='wrapper'>
          <GuideFilter numDays={this.props.numDays} destination={this.props.destination} pace={this.props.pace} startingDate={this.props.startingDate} filter={this.props.filter} onChange={this.props.onChange} isSmallScreen={false} showDateSelector={ true } showDestinationSelector={ false } />
          <div className='col-sm-12'>
            <div className='btn close-btn' onClick={ this.toggleShow }>Save</div>
          </div>
        </div>
        <div className='menu-pointer'></div>
          
      </div>
    )

    // return (
    //     <div className="filter-summary col-xs-12">
    //     <p>{numPlaces} {this.props.numDays} Days, {this.getPace()} Pace,
    //        Starting on {this.props.startingDate.format('MMM D, YYYY')}</p>
    //     {filterSelection}
    //     </div>
    // );
  }
});

var GuideHeader = React.createClass({

  render: function(){
    //    var loading = this.props.loading ? <img className="header loading" src="/images/ajax-loader.gif" /> : null ;
    var loading = null;
    var destName = _.startCase(this.props.destination).replace('Washington Dc', 'Washington DC').replace('New York', 'New York City');
    var mobileHeader = (this.props.isSmallScreen) ? <MobileGuideHeader pace={this.props.pace} numDays={this.props.numDays} startingDate={this.props.startingDate} filter={this.props.filter} mobileCurrentView={this.props.mobileCurrentView} onChangeView={ this.props.onChangeView } onChange={ this.props.onChange } numPlaces={this.props.numPlaces} /> : null;
    var destBreadcrumb = (this.props.isSmallScreen) ? null : (      
          <div className="bar clearfix text-uppercase">
        <a href={"/" + this.props.destination + "/"}>&lt; { destName }</a>
      </div>
    );
    return (
      <div className="header guide-header row">
        <div className="col-xs-12">
          {destBreadcrumb}
          <div className="trip-title" style={{ float: 'left' }}>
            <h1>{destName} Travel Guide <sup>beta</sup> {loading}</h1>
          </div> 
        </div>
        { mobileHeader }
      </div>
    );
  }
});

var TravelGuide = React.createClass({

  defaults: {
    numDays: 3,
    pace: 2,
    startingDate: moment().add(7, 'days'),
    filter: []
  },
  
  updateQueryStringParam: function(key, value) {
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
    var urlQueryString = document.location.search;
    var newParam = key + '=' + value,
        params = '?' + newParam;
    
    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      var keyRegex = new RegExp('([\?&])' + key + '[^&]*');
      // If param exists already, update it
      if (urlQueryString.match(keyRegex) !== null) {
        params = urlQueryString.replace(keyRegex, "$1" + newParam);
      } else { // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    }
    window.history.replaceState({}, "", baseUrl + params);
  },
  
  updateURL: function(params) {
    this.updateQueryStringParam('num-days', params.numDays);
    this.updateQueryStringParam('pace', params.pace);
    this.updateQueryStringParam('starting-date', moment(params.startingDate).format('YYYY-MM-DD'));
    this.updateQueryStringParam('filter', params.filter.map(function(f) { return f.toLowerCase(); }));
  },

  trackEvent: function() {
    ga('send', 'pageview', { page: location.pathname + location.search, nonInteraction: true });
  },
  
  getParameterByName: function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  },
  
  getInitialParams: function() {
    var params = {};
    params.numDays = this.getParameterByName('num-days') || this.defaults.numDays;
    if (typeof params.numDays === 'string') {
      params.numDays = parseInt(params.numDays);
    }
    params.pace = this.getParameterByName('pace') || this.defaults.pace;
    if (typeof params.pace === 'string') {
      params.pace = parseInt(params.pace);
    }
    params.startingDate = this.getParameterByName('starting-date') || this.defaults.startingDate;
    if (typeof params.startingDate === 'string') {
      params.startingDate = moment(params.startingDate);
    }
    params.filter = this.getParameterByName('filter') || this.defaults.filter;
    if (typeof params.filter === 'string') {
      params.filter = params.filter.split(/,/).map(function(f) { return f.toLowerCase(); });
    }

    params.destination = window.location.pathname.replace(/\/([^/]+)\/(guide|trip).*/, "$1");
    params.mobileCurrentView = (this.getParameterByName('hideFilters') == "1") ? "list-view" : "filter-view" //cookies.get"filter-view" : "list-view";

    return params;
  },
  
  getInitialState: function() {
    var params = this.getInitialParams();
    var initState = {
      numPlaces: 0,
      loading: false,
      isSmallScreen: false,
      mobileCurrentView: 'list-view',
      viewType: 'list-view'
    };
    return _.extend(initState, params);
  },

  componentDidMount: function() {
    this.fetchGuide();
    this.updateScreenType();
    window.addEventListener('resize', this.handleResize);

    setTimeout(() => FavoritesAPI.getAllFavorites(), 200);
    UserStore.addChangeListener(this.onChangeLogin);
  },

  componentWillUnmount: function() {
    window.removeEventListener('resize', this.handleResize);

    UserStore.removeChangeListener(this.onChangeLogin);
  },

  handleResize: function(e) {
    this.updateScreenType();
  },

  updateScreenType: function(){
    this.setState({
      isSmallScreen: ($(window).width() < 768) ? true : false
    });
  },

  onChangeView: function(view) {
    this.setState({
      mobileCurrentView: view
    });
  },

  onChangeLogin: function() {
    if (UserStore.isLoginRequired) {
      this.setState({loginRequired: true}, () =>
                    this.setState({loginRequired: false}));
    }
  },

  getWeekday: function(date) {
    return moment(date).format("dddd").toLowerCase();
  },
  
  onFilterChange: function(numDays, pace, startingDate, filter, view) {
    this.setState({
      numDays: parseInt(numDays),
      pace: parseInt(pace),
      startingDate: startingDate,
      filter: filter,
      mobileCurrentView: view ? view : this.state.mobileCurrentView
    }, function() {
      this.fetchGuide();
      this.updateURL({numDays: numDays, pace: pace, startingDate: startingDate, filter: filter});
      this.trackEvent();
    });
  },

  fetchGuide: function() {
    var that = this;
    var filters = this.state.filter;

    var filterQuery = (filters && filters.length > 0) ? ( '&filter=' + filters.join(',') ) : '';
    that.setState({loading: true, plan: undefined});

    $.get('http://guide.ruebarue.com/api/idea/' + this.state.destination + '?num-days=' + this.state.numDays + '&pace=' + this.state.pace + '&starting-weekday=' + this.getWeekday(this.state.startingDate) + filterQuery)
      .done(function(data){
       var placeIndex = 1;
       
       //TODO: This should be changed on the backend instead of this hack
       data.groups = data['trip-days'];
       delete data['trip-days'];

       data.groups.forEach(function(group, index){
         group.items.forEach(function(item) {
           item.placeIndex = placeIndex++;
         });

          group.name = moment(that.state.startingDate).add(index, 'days').format('dddd, MMM D, YYYY');
          group.icon = "icon-day-num icon-icons_day_" + (index + 1); 
       });

       that.setState({plan: data, loading: false});
    });
  },
  
  render: function() {
    var self = this;
    
    var displayOptions: {
      useMapHeader: true;
    }

    var guideApi = {
      updateState: function(obj){ self.setState(obj); },
    }

    return (
      <div>
        <GuideHeader numDays={this.state.numDays} destination={this.state.destination} pace={this.state.pace} startingDate={this.state.startingDate} 
                     filter={this.state.filter}
                     isSmallScreen={this.state.isSmallScreen}
                     loading={this.state.loading}
                     mobileCurrentView={this.state.mobileCurrentView}
                     numPlaces={this.state.numPlaces}
                     onChangeView={this.onChangeView}
                     onChange={this.onFilterChange} />

        <section className="container">
          <GuideFilter numDays={this.state.numDays} destination={this.state.destination} pace={this.state.pace} startingDate={this.state.startingDate} filter={this.state.filter} onChange={this.onFilterChange} isSmallScreen={this.state.isSmallScreen} showDateSelector={ true } showDestinationSelector={ false } />
          <PageGroups plan={this.state.plan} groups={ (!!this.state.plan ? this.state.plan.groups : []) } startingDate={this.state.startingDate} numPlaces={this.state.numPlaces}
                      isSmallScreen={this.state.isSmallScreen} filter={this.state.filter}
                      mobileCurrentView={this.state.mobileCurrentView} loading={this.state.loading}
                      onChangeView={this.onChangeView} numDays={this.state.numDays} destination={this.state.destination} pace={this.state.pace}
                      onChange={this.onFilterChange} viewType={ this.state.viewType } mapFor=".day:not(:last)" guideApi={ guideApi } guideState={ this.state } autoImageUrls={ true }/>
          <div className="footnote">
            Hours and days of operation are subject to change. Consult the attraction’s website for the most up-to-date information.
          </div>
        </section>
        <LoginModal loginRequired={this.state.loginRequired}/>
      </div>
    );
  }
});

module.exports = TravelGuide;



// WEBPACK FOOTER //
// ./components/guide.js